export enum MaintenanceResult {
  OK = 'OK',
  OK_WITH_RESTRICTIONS = 'OK_WITH_RESTRICTIONS',
  NOT_OK = 'NOT_OK',
  NO_RESULT_AVAILABLE = 'NO_RESULT_AVAILABLE'
}
